import "core-js/modules/web.dom-collections.iterator.js";
import { cssLinks } from "@ttark/css-links";
import { Root, RootErrorBoundary, RootLayout } from "~/routes/#root";
import { Root as RootV2, RootErrorBoundary as RootErrorBoundaryV2, RootLayout as RootLayoutV2 } from "~/routes/#root/index.hydration";
import { buildMasterLoader } from "~/utils/build-master-loader";
var links = () => [...cssLinks("root")];
var loader = buildMasterLoader("root");
var shouldRevalidate = () => false;
var ErrorBoundary = __BUILD_VARIANT__ === "hydrate_root" ? RootErrorBoundaryV2 : RootErrorBoundary;
var Layout = __BUILD_VARIANT__ === "hydrate_root" ? RootLayoutV2 : RootLayout;
var Page = __BUILD_VARIANT__ === "hydrate_root" ? RootV2 : Root;
var root_default = Page;
export { ErrorBoundary, Layout, root_default as default, links, shouldRevalidate };